import { Component, Inject, Input } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ModalLayoutComponent } from '../modal-layout/modal-layout.component';
import { NgStyle } from '@angular/common';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-global-message-modal',
  templateUrl: './global-message.component.html',
  styleUrls: ['./global-message.component.scss'],
  imports: [ModalLayoutComponent, NgStyle, RouterLink],
  standalone: true,
})
export class GlobalMessageComponent {
  @Input() minHeight: string = 'unset';
  constructor(
    public dialogRef: MatDialogRef<GlobalMessageComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      title: string;
      text: string;
      link: string;
      linkText: string;
    },
  ) {}

  close(state = 0): void {
    this.dialogRef.close({ state: state });
  }
}
